import React from "react"
import { clBasic, colores, borderSubMain } from "./general"

export default function Story({ story, setRefresh }) {
    let color = colores["prioridad"];

    function drag(e) {
        let data = { obj: "story", historia: story.id };
        e.dataTransfer.setData("text", JSON.stringify(data));

    }

    function dragEnd(e) {
        setRefresh(r => !r)
    }

    return (
        <div style={Sstory} draggable="true" onDragStart={(e) => drag(e)} onDragEnd={(e) => dragEnd(e)} >
            <div style={Slinea1}>
                <div style={Snombre}>
                    {story.nombre}
                </div>
                <div style={{ ...Scirculo, background: color[story.prioridad] }}></div>
            </div>

            <div style={Slinea2}>
                <div >
                    {`${story.horas} horas`}
                </div>
                <div >
                    {`${story.puntos} puntos`}
                </div>
            </div>

        </div>
    )
}

const Sstory = {
    width: "95%",
    background: "white",
    border: `3px outset ${borderSubMain}`,
    borderRadius: "0px 20px 0px  0px",
    color: clBasic,
    margin: "7px 7px 0px 7px "
}

const Slinea1 = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "7px 7px 0px 7px",
    fontSize: "2.1vh",
    fontWeight: 600,
}

const Snombre = {
    width: "80%",
    whiteSpace: "nowrap",
    overflow: "hidden"
}

const Slinea2 = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "0px 7px 7px 7px",
    fontSize: "1.8vh"
}

const Scirculo = {
    height: "20px",
    width: "20px",
    padding: "5px",
    borderRadius: "50%",
}